import { createContext, Dispatch, PropsWithChildren, useReducer } from 'react';
import { campaignEditorDefaultState, campaignEditorReducer } from './campaignEditorReducer';
import { CampaignEditorAction, CampaignEditorState } from './CampaignEditorState';

export const CampaignEditorStateContext = createContext<{
  state: CampaignEditorState;
  dispatch: Dispatch<CampaignEditorAction>;
}>({
  state: campaignEditorDefaultState,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {},
});

export interface CampaignEditorStateProviderProps {
  status: CampaignEditorState['status'];
  readOnly: CampaignEditorState['readOnly'];
  campaign: CampaignEditorState['campaign'];
}

export const CampaignEditorStateProvider = ({
  children,
  status,
  readOnly,
  campaign,
}: PropsWithChildren<CampaignEditorStateProviderProps>) => {
  const [state, dispatch] = useReducer(campaignEditorReducer, {
    ...campaignEditorDefaultState,
    status,
    readOnly,
    campaign,
  });

  return (
    <CampaignEditorStateContext.Provider value={{ state, dispatch }}>{children}</CampaignEditorStateContext.Provider>
  );
};
